import { graphql } from "gatsby"
import React, { useState, useEffect } from "react"
import * as styles from "./slider-v2.module.scss"
import { ArticleSliderFieldsFragment } from "../../../../../../graphql-types"
import StructuredTextContent from "../structured-text-content/structured-text-content"
import { ReactSVG } from "react-svg"
import arrow from "../../../../../../static/vectors/arrowV2.svg"
import backArrow from "../../../../../../static/vectors/backArrowV2.svg"

type SliderProps = {
    data: ArticleSliderFieldsFragment
  }

const SliderV2: React.FC<SliderProps> = ({ data }) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isMobile, setIsMobile] = useState(false)
  const nextIndex = (currentIndex + 1) % data.sliderContent.length

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 825)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % data.sliderContent.length)
  }

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + data.sliderContent.length) % data.sliderContent.length)
  }

  return (
    <div>
      <div className={styles.sliderContainer}>
        <div className={styles.buttonsInfosContainer}>
            <div className={styles.buttonsContainer}>
                <button className={styles.button} onClick={prevSlide} aria-label="Previous slide">
                    <ReactSVG className={styles.icon} src={backArrow} />
                </button>
                <button className={styles.button} onClick={nextSlide} aria-label="Next slide">
                    <ReactSVG className={styles.icon} src={arrow} />
                </button>
            </div>
            <div className={styles.imageInfo}>
                <h3 className={styles.imageTitle}>{data.sliderContent[currentIndex].pictureTitle}</h3>
                <StructuredTextContent data={data.sliderContent[currentIndex].pictureCaption.value} isNotRichContent={true} />
            </div>            
        </div>
        <div className={styles.mainImageContainer}>
          <img
            className={styles.mainImage}
            src={data.sliderContent[currentIndex].picture.url}
            alt={data.sliderContent[currentIndex].picture.alt}
          />
        </div>
        <div className={styles.nextImageContainer} style={{ display: isMobile ? 'none' : 'flex' }}>
          <img
            className={styles.nextImage}
            src={data.sliderContent[nextIndex].picture.url}
            alt={data.sliderContent[nextIndex].picture.alt}
          />
        </div>
      </div>
    </div>
  )
}

export const fragment = graphql`
  fragment ArticleSliderFields on DatoCmsArticleSlider {
    __typename
    id
    sliderContent {
      picture {
        alt
        format
        title
        url
      }
      pictureTitle
      pictureCaption {
        value
      }
    }
  }
`

export default SliderV2